import type { ActivePurchaseType } from '../../types/activePurchases.types'
import type { InactivePurchaseType } from '../../types/inactivePurchases.types'
import type { AllUserInfo, UserInfo } from '../../types/user.types'

export const myAccountReducer = (
	allUserInfo: AllUserInfo,
	newUserInfo: UserInfo
): AllUserInfo => {
	const copyAllUserInfo = { ...allUserInfo }
	copyAllUserInfo.userInfo[newUserInfo.userInfoType] =
		newUserInfo.userInfo as ActivePurchaseType[] & InactivePurchaseType[]
	return copyAllUserInfo
}
